import bus from "../../admin-bus";
import { MODAL_OPEN, MODAL_CLOSE, MODAL_UPDATE } from "../../action-types";
import addClass from "../../utilities/add-class";
import removeClass from "../../utilities/remove-class";
import viewloader from "viewloader";
import views from "../../views";

/**
 * Establish a modal listening for events from the event bus.
 * @param  {Node} el Element
 * @return {Void}
 */

export default function modal(el) {
  const modalElement = el.querySelector(".modal");
  const modalContainerElement = modalElement.querySelector(".modal__container");
  const viewManager = viewloader(views, modalContainerElement);
  let isOpen = false;
  let successCallback = false;

  function openModal(options) {
    if (options.onSuccess) {
      successCallback = options.onSuccess;
    }

    if (options.content) {
      modalContainerElement.innerHTML = options.content;
      viewManager.callViews();
    }

    removeClass(el, "closed");
    registerEventListeners();
    isOpen = true;
  }

  function closeModal(options = {}) {
    addClass(el, "closed");
    deregisterEventListeners();
    viewManager.destroyViews();
    isOpen = false;

    if (options.success && successCallback) {
      successCallback(options.data);
    }
  }

  function updateModal(options) {
    viewManager.destroyViews();

    if (options.content) {
      modalContainerElement.innerHTML = options.content;
      viewManager.callViews();
    }
  }

  function handleOutsideMouseClick(e) {
    if (!isOpen) {
      return;
    }

    if (modalContainerElement && modalContainerElement.contains(e.target)) {
      return;
    }

    e.stopPropagation();
    closeModal();
  }

  bus.on(MODAL_OPEN, openModal);
  bus.on(MODAL_UPDATE, updateModal);
  bus.on(MODAL_CLOSE, closeModal);

  function registerEventListeners() {
    document.addEventListener("mousedown", handleOutsideMouseClick);
    document.addEventListener("touchstart", handleOutsideMouseClick);
  }

  function deregisterEventListeners() {
    document.removeEventListener("mousedown", handleOutsideMouseClick);
    document.removeEventListener("touchstart", handleOutsideMouseClick);
  }

  function deregisterFromEventBus() {
    bus.off(MODAL_OPEN, openModal);
    bus.off(MODAL_UPDATE, updateModal);
    bus.off(MODAL_CLOSE, closeModal);
  }

  function destroy() {
    deregisterFromEventBus();
  }

  return {
    destroy: destroy
  };
}
